import {
  ChangeDetectionStrategy, Component,
} from '@angular/core'

@Component({
  selector: 'button[kb-button], a[kb-button]',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class ButtonComponent {

}
